var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "./modules/components/validationFieldInput", "./modules/constants", "./modules/models/holderValidationRequest", "./modules/models/viewModels/holderValidationViewModel", "./modules/services/requests/loginFlowRequest", "./modules/services/toastNotification", "./modules/utils", "./mfaModal", "./modules/utils/timer", "./modules/components/uploadModal"], function (require, exports, validationFieldInput_1, constants_1, holderValidationRequest_1, holderValidationViewModel_1, loginFlowRequest_1, toastNotification_1, utils_1, mfaModal_1, timer_1, uploadModal_1) {
    "use strict";
    var _a, _b, _c;
    Object.defineProperty(exports, "__esModule", { value: true });
    validationFieldInput_1 = __importDefault(validationFieldInput_1);
    holderValidationRequest_1 = __importDefault(holderValidationRequest_1);
    holderValidationViewModel_1 = __importDefault(holderValidationViewModel_1);
    loginFlowRequest_1 = __importDefault(loginFlowRequest_1);
    utils_1 = __importDefault(utils_1);
    timer_1 = __importDefault(timer_1);
    var accessModal = document.querySelector('#access-modal');
    var accessModalBtnClose = document.querySelector('#access-modal-close');
    var accessModalBtnCancel = document.querySelector('#access-modal-cancelar');
    var accessModalBtnConfirm = document.querySelector('#access-modal-confirmar');
    var accessModalTxtSearch = document.querySelector('#access-modal-pesquisa');
    var accessModalTxtFoundRecords = document.querySelector('#txtAccessModalRegistrosEncontrados');
    var accessModalBtnAddNewHolders = document.querySelector('#access-modal-add-novos-titulares');
    var linkModal = document.querySelector('#link-data-modal');
    var linkModalBtnClose = document.querySelector('#link-data-modal-close');
    var linkModalBtnCancel = document.querySelector('#link-data-modal-cancelar');
    var linkModalBtnConfirm = document.querySelector('#link-data-modal-confirmar');
    var linkModalTxtSearch = document.querySelector('#link-data-modal-pesquisa');
    var linkModalTxtFoundRecords = document.querySelector('#txtLinkModalRegistrosEncontrados');
    var validationModal = document.querySelector('#holder-validation-modal');
    var validationModalBody = document.querySelector('#holder-validation-modal-body');
    var validationModalForm = document.querySelector('#holder-validation-modal-form');
    var validationModalBtnClose = document.querySelector('#holder-validation-modal-close');
    var validationModalBtnCancel = document.querySelector('#holder-validation-modal-fechar');
    var validationModalBtnConfirm = document.querySelector('#holder-validation-modal-validar');
    var validationModalSpanAttempts = document.querySelector("#attempts");
    var validationModalSpanAttemptsText = document.querySelector("#attemptsText");
    var validationModalSpanNextAttemptTimer = document.querySelector("#nextAttempt");
    var validationModalSpanNextAttemptTimerText = document.querySelector("#nextAttemptText");
    var validationModalDivNextAttempt = document.querySelector("#divNextAttempt");
    var mfaSize = document.querySelector("#mfa-size");
    var signInForm = document.querySelector('#signInForm');
    var txtHolderId = document.querySelector('#txtHolderId');
    var txtImportedHolderInfoId = document.querySelector('#txtImportedHolderInfoId');
    var holderDataIdentifier = '.holder-data';
    var holderLoginIdentifier = '.holder-access';
    var dataValidationEnabled = ((_a = document.querySelector('#txtDataValidationEnabled')) === null || _a === void 0 ? void 0 : _a.value) == "S";
    var docsValidationEnabled = ((_b = document.querySelector('#txtDocsValidationEnabled')) === null || _b === void 0 ? void 0 : _b.value) == "S";
    var blockedFieldClassList = ['cursor-not-allowed', 'bg-gray-300'];
    var releasedFieldClassList = ['bg-gray-100', 'hover:border-gray-500'];
    var defaultToastMs = 5000;
    var hasHoldersToBeLinked = ((_c = document.querySelector('#txtHasHoldersToBeLinked')) === null || _c === void 0 ? void 0 : _c.value) == "S";
    var selectedHolderToBeLinked;
    var validationData;
    var setIntervalId = 0;
    var mfaModal;
    var timer;
    var uploadModal;
    var normalizeValidationInputValue = function (item, value) {
        var _a;
        var inputValue = (_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '';
        if ((item === null || item === void 0 ? void 0 : item.propertyName) !== 'DataNascimento')
            return inputValue;
        var digitsOnly = inputValue.replace(/\D/g, '');
        if ((item === null || item === void 0 ? void 0 : item.characterPosition) === 'first' && digitsOnly.length >= 4)
            return digitsOnly.substring(0, 2) + "/" + digitsOnly.substring(2, 4);
        if ((item === null || item === void 0 ? void 0 : item.characterPosition) === 'last')
            return digitsOnly.substring(0, 4);
        return inputValue;
    };
    var applyBirthDateDayMonthMask = function (input) {
        input.maxLength = 5;
        input.inputMode = 'numeric';
        input.addEventListener('input', function () {
            var digitsOnly = input.value.replace(/\D/g, '').substring(0, 4);
            input.value = digitsOnly.length > 2
                ? digitsOnly.substring(0, 2) + "/" + digitsOnly.substring(2)
                : digitsOnly;
        });
    };
    var onLoginFlowLoad = function () {
        var _a, _b;
        accessModalTxtSearch === null || accessModalTxtSearch === void 0 ? void 0 : accessModalTxtSearch.addEventListener('keyup', function () { return helpers.modalSearch(holderLoginIdentifier, accessModalTxtSearch.value, accessModalTxtFoundRecords); });
        linkModalTxtSearch === null || linkModalTxtSearch === void 0 ? void 0 : linkModalTxtSearch.addEventListener('keyup', function () { return helpers.modalSearch(holderDataIdentifier, linkModalTxtSearch.value, linkModalTxtFoundRecords); });
        accessModalBtnClose === null || accessModalBtnClose === void 0 ? void 0 : accessModalBtnClose.addEventListener('click', accessModalClose);
        accessModalBtnCancel === null || accessModalBtnCancel === void 0 ? void 0 : accessModalBtnCancel.addEventListener('click', accessModalClose);
        linkModalBtnClose === null || linkModalBtnClose === void 0 ? void 0 : linkModalBtnClose.addEventListener('click', linkModalClose);
        linkModalBtnCancel === null || linkModalBtnCancel === void 0 ? void 0 : linkModalBtnCancel.addEventListener('click', linkModalClose);
        validationModalBtnClose.addEventListener('click', validationModalClose);
        validationModalBtnCancel.addEventListener('click', validationModalClose);
        accessModalBtnConfirm === null || accessModalBtnConfirm === void 0 ? void 0 : accessModalBtnConfirm.addEventListener('click', login);
        linkModalBtnConfirm === null || linkModalBtnConfirm === void 0 ? void 0 : linkModalBtnConfirm.addEventListener('click', function () { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!hasHoldersToBeLinked) return [3, 2];
                    return [4, linkSelectedHolderData()];
                case 1:
                    _a = _b.sent();
                    return [3, 4];
                case 2: return [4, cancelNewHoldersLink()];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4: return [2, _a];
            }
        }); }); });
        validationModalForm.addEventListener('submit', validateInputedData);
        accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.addEventListener('click', requestNewHoldersLink);
        (_a = document.querySelectorAll(holderDataIdentifier)) === null || _a === void 0 ? void 0 : _a.forEach(function (el) { return el.addEventListener('click', selectHoldersToBeLinked); });
        (_b = document.querySelectorAll(holderLoginIdentifier)) === null || _b === void 0 ? void 0 : _b.forEach(function (el) { return el.addEventListener('click', selectLogin); });
        var mfaLength = Number(mfaSize.value);
        if (mfaLength > 0) {
            mfaModal = new mfaModal_1.MfaModal((Number)(mfaLength), signInForm);
            timer = new timer_1.default('mfa-expiration', 'tempo-restante');
            timer.start();
        }
    };
    var accessModalClose = function () {
        var _a;
        accessModal === null || accessModal === void 0 ? void 0 : accessModal.classList.add('hidden');
        (_a = document.querySelectorAll(holderLoginIdentifier)) === null || _a === void 0 ? void 0 : _a.forEach(function (el) {
            el.classList.remove('hidden');
            el.classList.remove('selected');
        });
        accessModalTxtSearch.value = '';
        txtImportedHolderInfoId.value = '';
    };
    var selectLogin = function (e) {
        var _a;
        var target = e.target.parentElement;
        if (!target) {
            toastNotification_1.ToastNotification.Error('Falha ao selecionar titular para realizar o login.', defaultToastMs);
            return;
        }
        if (target.classList.contains('selected')) {
            target.classList.remove('selected');
            txtImportedHolderInfoId.value = '';
            return;
        }
        (_a = document.querySelectorAll(holderLoginIdentifier)) === null || _a === void 0 ? void 0 : _a.forEach(function (el) { return el.classList.remove('selected'); });
        target === null || target === void 0 ? void 0 : target.classList.add('selected');
        txtImportedHolderInfoId.value = String(target.dataset.id);
    };
    var login = function () {
        if (!(txtImportedHolderInfoId === null || txtImportedHolderInfoId === void 0 ? void 0 : txtImportedHolderInfoId.value)) {
            toastNotification_1.ToastNotification.Error('Selecione um titular para realizar o login.', defaultToastMs);
            return;
        }
        signInForm === null || signInForm === void 0 ? void 0 : signInForm.submit();
    };
    var requestNewHoldersLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    helpers.toggleBtnAddNewHolders(false);
                    return [4, loginFlowRequest_1.default.requestNewHoldersLink(helpers.getHolderRoute(), txtHolderId.value)];
                case 1:
                    _d.sent();
                    accessModalClose();
                    signInForm === null || signInForm === void 0 ? void 0 : signInForm.submit();
                    return [3, 4];
                case 2:
                    error_1 = _d.sent();
                    console.error(error_1);
                    toastNotification_1.ToastNotification.Error((_c = (_b = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : constants_1.DefaultError, defaultToastMs);
                    return [3, 4];
                case 3:
                    helpers.toggleConfirmButton(linkModalBtnConfirm, true);
                    helpers.toggleBtnAddNewHolders(true);
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    var linkModalClose = function () {
        var _a;
        linkModal === null || linkModal === void 0 ? void 0 : linkModal.classList.add('hidden');
        (_a = document.querySelectorAll(holderDataIdentifier)) === null || _a === void 0 ? void 0 : _a.forEach(function (el) {
            el.classList.remove('hidden');
            el.classList.remove('selected');
        });
        linkModalTxtSearch.value = '';
        if (!dataValidationEnabled && !docsValidationEnabled)
            selectedHolderToBeLinked = null;
    };
    var selectHoldersToBeLinked = function (e) {
        var _a;
        var target = e.target.parentElement;
        if (!target) {
            toastNotification_1.ToastNotification.Error('Falha ao selecionar titular para realizar o vínculo.', defaultToastMs);
            return;
        }
        if (target.classList.contains('disabled'))
            return;
        (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.querySelectorAll('tr').forEach(function (el) { return el.classList.remove('selected'); });
        var pk = String(target.dataset.pk);
        var operationCode = Number(target.dataset.operation);
        selectedHolderToBeLinked = { pk: pk, operationCode: operationCode };
        target === null || target === void 0 ? void 0 : target.classList.add('selected');
    };
    var cancelNewHoldersLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    helpers.toggleConfirmButton(linkModalBtnConfirm, false);
                    return [4, loginFlowRequest_1.default.cancelNewHoldersLink(helpers.getHolderRoute(), txtHolderId.value)];
                case 1:
                    _d.sent();
                    linkModalClose();
                    signInForm === null || signInForm === void 0 ? void 0 : signInForm.submit();
                    return [3, 4];
                case 2:
                    error_2 = _d.sent();
                    console.error(error_2);
                    toastNotification_1.ToastNotification.Error((_c = (_b = (_a = error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : constants_1.DefaultError, defaultToastMs);
                    return [3, 4];
                case 3:
                    helpers.toggleConfirmButton(linkModalBtnConfirm, true);
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    var linkSelectedHolderData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, msg, validationStatus, error_3;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 13, 14, 15]);
                    if (!selectedHolderToBeLinked) {
                        toastNotification_1.ToastNotification.Error('Selecione um titular para vincular ao seu login.', defaultToastMs);
                        return [2];
                    }
                    helpers.toggleConfirmButton(linkModalBtnConfirm, false);
                    if (!docsValidationEnabled) return [3, 7];
                    return [4, loginFlowRequest_1.default.getValidationDocsStatus(helpers.getHolderRoute(), Number(txtHolderId.value), selectedHolderToBeLinked.operationCode)];
                case 1:
                    response = _e.sent();
                    _a = response === null || response === void 0 ? void 0 : response.docsValidationStatus;
                    switch (_a) {
                        case 0: return [3, 2];
                        case 1: return [3, 3];
                    }
                    return [3, 5];
                case 2:
                    toastNotification_1.ToastNotification.Error(response.message, 20000);
                    return [3, 6];
                case 3: return [4, loginFlowRequest_1.default.linkHolders({
                        route: helpers.getRoute(),
                        holderId: Number(txtHolderId === null || txtHolderId === void 0 ? void 0 : txtHolderId.value),
                        selectedHoldersToBeLinked: [selectedHolderToBeLinked]
                    })];
                case 4:
                    _e.sent();
                    signInForm === null || signInForm === void 0 ? void 0 : signInForm.submit();
                    return [3, 6];
                case 5:
                    msg = (response === null || response === void 0 ? void 0 : response.docsValidationStatus) === 2 ?
                        "Os documentos enviados foram analisados, mas não foram aprovados pelo DPO. " +
                            "Por favor, envie novamente os documentos corrigidos ou complementares para que possamos dar continuidade à análise." :
                        "Os documentos enviados estão expirados, pois a análise não foi realizada dentro do prazo, é necessário enviá-los novamente.";
                    toastNotification_1.ToastNotification.Error(msg, 20000);
                    uploadModal = new uploadModal_1.UploadModal();
                    uploadModal.addOnConfirmClick(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var docs, formData, response_1;
                        var _a, _b, _c, _d;
                        var _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                        return __generator(this, function (_q) {
                            switch (_q.label) {
                                case 0:
                                    docs = (_e = uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.fileList) !== null && _e !== void 0 ? _e : new Map();
                                    if (docs.size <= 0) {
                                        toastNotification_1.ToastNotification.Error('É necessário enviar ao menos uma foto ou imagem do documento informado no cadastro.');
                                        return [2];
                                    }
                                    if (!((_f = uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.GetCbxUpload()) === null || _f === void 0 ? void 0 : _f.checked)) {
                                        toastNotification_1.ToastNotification.Error('É necessário confirmar que o(s) arquivos(s) enviado(s) são referentes ao documento informado.');
                                        return [2];
                                    }
                                    formData = new FormData();
                                    formData.append('OperationCode', selectedHolderToBeLinked.operationCode.toString());
                                    uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.fileList.forEach(function (file, _) {
                                        formData.append('Documents', file);
                                    });
                                    _q.label = 1;
                                case 1:
                                    _q.trys.push([1, , 3, 4]);
                                    (_g = uploadModal.GetBtnConfirm()) === null || _g === void 0 ? void 0 : (_a = _g.classList).add.apply(_a, uploadModal._disabledClassesForButton);
                                    (_h = uploadModal.GetBtnConfirm()) === null || _h === void 0 ? void 0 : (_b = _h.classList).remove.apply(_b, uploadModal._enabledClassesForButton);
                                    (_j = uploadModal.GetBtnConfirm()) === null || _j === void 0 ? void 0 : _j.setAttribute('disabled', 'disabled');
                                    return [4, loginFlowRequest_1.default.createNewDocsValidation(helpers.getHolderRoute(), txtHolderId.value, formData)];
                                case 2:
                                    response_1 = _q.sent();
                                    toastNotification_1.ToastNotification.Success((_l = (_k = response_1.data) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : 'Documentos enviados para validação com sucesso.');
                                    return [3, 4];
                                case 3:
                                    (_m = uploadModal.GetBtnConfirm()) === null || _m === void 0 ? void 0 : (_c = _m.classList).remove.apply(_c, uploadModal._disabledClassesForButton);
                                    (_o = uploadModal.GetBtnConfirm()) === null || _o === void 0 ? void 0 : (_d = _o.classList).add.apply(_d, uploadModal._enabledClassesForButton);
                                    (_p = uploadModal.GetBtnConfirm()) === null || _p === void 0 ? void 0 : _p.removeAttribute('disabled');
                                    return [7];
                                case 4: return [2];
                            }
                        });
                    }); });
                    return [3, 6];
                case 6: return [3, 12];
                case 7:
                    if (!dataValidationEnabled) return [3, 10];
                    return [4, generateValidationFields()];
                case 8:
                    _e.sent();
                    return [4, loginFlowRequest_1.default.getValidationStatus(helpers.getHolderRoute(), txtHolderId.value)];
                case 9:
                    validationStatus = _e.sent();
                    validationNextAttempt(validationStatus, '');
                    validationModal.classList.remove('hidden');
                    return [3, 12];
                case 10: return [4, loginFlowRequest_1.default.linkHolders({
                        route: helpers.getRoute(),
                        holderId: Number(txtHolderId === null || txtHolderId === void 0 ? void 0 : txtHolderId.value),
                        selectedHoldersToBeLinked: [selectedHolderToBeLinked]
                    })];
                case 11:
                    _e.sent();
                    signInForm === null || signInForm === void 0 ? void 0 : signInForm.submit();
                    _e.label = 12;
                case 12:
                    linkModalClose();
                    return [3, 15];
                case 13:
                    error_3 = _e.sent();
                    console.error(error_3);
                    toastNotification_1.ToastNotification.Error((_d = (_c = (_b = error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : constants_1.DefaultError, 20000);
                    return [3, 15];
                case 14:
                    helpers.toggleConfirmButton(linkModalBtnConfirm, true);
                    return [7];
                case 15: return [2];
            }
        });
    }); };
    var validationModalClose = function () {
        validationModal.classList.add('hidden');
        validationData = null;
    };
    var generateValidationFields = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, validationHtml, properties;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, loginFlowRequest_1.default.getValidationFields(helpers.getHolderRoute(), [selectedHolderToBeLinked].map(function (x) { return x.pk; }), txtHolderId.value)];
                case 1:
                    data = _a.sent();
                    validationData = data;
                    validationHtml = '';
                    validationData.forEach(function (item) {
                        var validationFieldInput = new validationFieldInput_1.default();
                        var holderValidation = new holderValidationViewModel_1.default(item.propertyName, item.characterPosition, item.numberOfDigits, null, null, item.sourceLength);
                        validationHtml += validationFieldInput.GetHtmlWithValues(holderValidation);
                    });
                    validationModalBody.innerHTML = validationHtml;
                    properties = [];
                    validationData.forEach(function (item) {
                        var inputs = validationModalBody.querySelectorAll("#" + item.propertyName);
                        var propertiesFound = properties.filter(function (prop) { return prop === item.propertyName; });
                        var input = inputs[propertiesFound.length];
                        if (item.propertyName === 'DataNascimento' && item.characterPosition === 'first' && input)
                            applyBirthDateDayMonthMask(input);
                        properties.push(item.propertyName);
                    });
                    return [2];
            }
        });
    }); };
    var validateInputedData = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var holderValidationInfo_1, properties_1, e_1, e_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    e.preventDefault();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 7, , 8]);
                    holderValidationInfo_1 = new holderValidationRequest_1.default([selectedHolderToBeLinked].map(function (x) { return x.pk; }), Number(txtHolderId === null || txtHolderId === void 0 ? void 0 : txtHolderId.value), []);
                    properties_1 = [];
                    validationData.forEach(function (item) {
                        var _a, _b;
                        var inputs = document.querySelectorAll("#" + item.propertyName);
                        var propertiesFound = properties_1.filter(function (prop) { return prop === item.propertyName; });
                        var input = inputs[propertiesFound.length];
                        var normalizedValue = normalizeValidationInputValue(item, input === null || input === void 0 ? void 0 : input.value);
                        var characterPosition = (_a = item.characterPosition) !== null && _a !== void 0 ? _a : 'first';
                        var numberOfCharacters = (_b = item.numberOfDigits) !== null && _b !== void 0 ? _b : input === null || input === void 0 ? void 0 : input.value.length;
                        var holderValidation = new holderValidationViewModel_1.default(item.propertyName, characterPosition, Number(numberOfCharacters), normalizedValue, Number(input === null || input === void 0 ? void 0 : input.dataset.index), item.sourceLength);
                        holderValidationInfo_1.holderValidationInfo.push(holderValidation);
                        properties_1.push(item.propertyName);
                    });
                    return [4, loginFlowRequest_1.default.validateData(helpers.getHolderRoute(), holderValidationInfo_1)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _d.trys.push([3, 5, , 6]);
                    return [4, loginFlowRequest_1.default.linkHolders({
                            route: helpers.getRoute(),
                            holderId: Number(txtHolderId === null || txtHolderId === void 0 ? void 0 : txtHolderId.value),
                            selectedHoldersToBeLinked: [selectedHolderToBeLinked]
                        })];
                case 4:
                    _d.sent();
                    validationModalClose();
                    signInForm === null || signInForm === void 0 ? void 0 : signInForm.submit();
                    return [3, 6];
                case 5:
                    e_1 = _d.sent();
                    toastNotification_1.ToastNotification.Error((_c = (_b = (_a = e_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : constants_1.DefaultError, defaultToastMs);
                    return [3, 6];
                case 6: return [3, 8];
                case 7:
                    e_2 = _d.sent();
                    validationNextAttempt(e_2.response.data.data, e_2.response.data.message);
                    return [3, 8];
                case 8: return [2];
            }
        });
    }); };
    var validationNextAttempt = function (data, errorMessage) {
        if (!data)
            return;
        if (!validationModalSpanAttempts || !validationModalSpanNextAttemptTimer || !validationModalDivNextAttempt)
            return;
        validationModalSpanAttemptsText.textContent = 'Tentativas restantes: ';
        validationModalSpanAttempts.textContent = String((data === null || data === void 0 ? void 0 : data.attempts));
        if ((data === null || data === void 0 ? void 0 : data.attempts) === 1) {
            toastNotification_1.ToastNotification.Error("Esta \u00E9 a \u00FAltima tentativa, caso seja informado errado novamente o processo de \n            vincula\u00E7\u00E3o ser\u00E1 bloqueado e voc\u00EA poder\u00E1 acessar novamente somente daqui a 10 minutos.", defaultToastMs);
            return;
        }
        if ((data === null || data === void 0 ? void 0 : data.attempts) === 0) {
            toastNotification_1.ToastNotification.Error("O n\u00FAmero de tentativas com dados incorretos foi excedido\n                                 Favor aguardar o tempo para pr\u00F3xima tentativa.", defaultToastMs);
            validationModalBody.querySelectorAll("input").forEach(function (item) { return helpers.blockField(item); });
            helpers.markRed(validationModalSpanAttempts);
            helpers.toggleConfirmButton(validationModalBtnConfirm, false);
            if (data === null || data === void 0 ? void 0 : data.nextAttempt) {
                helpers.showElement(validationModalDivNextAttempt);
                validationModalSpanNextAttemptTimerText.textContent = 'Próxima tentativa em: ';
                validationModalSpanNextAttemptTimer.textContent = data.nextAttempt.split('.')[0];
                setIntervalId = window.setInterval(validationTimer, 1000);
            }
            return;
        }
        if (errorMessage)
            toastNotification_1.ToastNotification.Error(errorMessage, defaultToastMs);
    };
    var validationTimer = function () {
        var _a, _b;
        if (!validationModalSpanNextAttemptTimer)
            return;
        var _c = (_b = (_a = validationModalSpanNextAttemptTimer.textContent) === null || _a === void 0 ? void 0 : _a.split(':')) !== null && _b !== void 0 ? _b : [], h = _c[0], m = _c[1], s = _c[2];
        var hour = Number(h);
        var minute = Number(m);
        var second = Number(s);
        if (second > 0) {
            second--;
        }
        else {
            second = 59;
            minute--;
            if (minute == 0 && hour > 0) {
                hour--;
            }
        }
        if (second === 0 && minute === 0 && hour === 0) {
            clearInterval(setIntervalId);
            window.location.reload();
        }
        var strHour = hour >= 10 ? String(hour) : "0" + String(hour);
        var strMinute = minute >= 10 ? String(minute) : "0" + String(minute);
        var strSecond = second >= 10 ? String(second) : "0" + String(second);
        if (validationModalSpanNextAttemptTimer)
            validationModalSpanNextAttemptTimer.textContent = strHour + ":" + strMinute + ":" + strSecond;
    };
    var helpers = {
        modalSearch: function (identifier, search, txtRecordsFound) {
            document.querySelectorAll(identifier).forEach(function (el) {
                var _a, _b, _c;
                var name = (_c = (_b = (_a = el.dataset.name) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== null && _c !== void 0 ? _c : '';
                if (search === '' || name.includes(search.toUpperCase()))
                    el.classList.remove('hidden');
                else
                    el.classList.add('hidden');
            });
            var recordsFound = document.querySelectorAll(identifier + ":not(.hidden)").length;
            txtRecordsFound.textContent = "Registros encontrados: " + recordsFound;
        },
        toggleConfirmButton: function (confirmButtom, enable) {
            if (enable) {
                confirmButtom === null || confirmButtom === void 0 ? void 0 : confirmButtom.classList.add('hover:border-linx-purple-1200', 'hover:bg-linx-purple-1200', 'bg-linx-purple-1100');
                confirmButtom === null || confirmButtom === void 0 ? void 0 : confirmButtom.classList.remove('cursor-not-allowed', 'bg-linx-purple-transparent-100');
                confirmButtom === null || confirmButtom === void 0 ? void 0 : confirmButtom.removeAttribute('disabled');
            }
            else {
                confirmButtom === null || confirmButtom === void 0 ? void 0 : confirmButtom.classList.remove('hover:border-linx-purple-1200', 'hover:bg-linx-purple-1200', 'bg-linx-purple-1100');
                confirmButtom === null || confirmButtom === void 0 ? void 0 : confirmButtom.classList.add('cursor-not-allowed', 'bg-linx-purple-transparent-100');
                confirmButtom === null || confirmButtom === void 0 ? void 0 : confirmButtom.setAttribute('disabled', 'disabled');
            }
        },
        toggleBtnAddNewHolders: function (enable) {
            if (enable) {
                accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.removeAttribute('disabled');
                accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.classList.add('cursor-pointer', 'hover:text-linx-purple-1200');
                accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.classList.remove('cursor-not-allowed');
            }
            else {
                accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.setAttribute('disabled', 'disabled');
                accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.classList.add('cursor-not-allowed');
                accessModalBtnAddNewHolders === null || accessModalBtnAddNewHolders === void 0 ? void 0 : accessModalBtnAddNewHolders.classList.remove('cursor-pointer', 'hover:text-linx-purple-1200');
            }
        },
        getHolderRoute: function () {
            var route = utils_1.default.findGetParameter('returnurl');
            var _a = route.split('/'), area = _a[1], endpoint = _a[2];
            var holderUrl = 'titular';
            return area + "/" + holderUrl + "/" + endpoint;
        },
        getRoute: function () { return utils_1.default.findGetParameter('returnurl'); },
        isVisible: function (element) { return !element.classList.contains('hidden'); },
        clearField: function (element) { return element.value = ''; },
        clearSelect: function (element) { return element.selectedIndex = 0; },
        blockField: function (element) {
            var _a, _b;
            (_a = element.classList).add.apply(_a, blockedFieldClassList);
            (_b = element.classList).remove.apply(_b, releasedFieldClassList);
            element.setAttribute('disabled', 'disabled');
        },
        releaseField: function (element) {
            var _a, _b;
            (_a = element.classList).add.apply(_a, releasedFieldClassList);
            (_b = element.classList).remove.apply(_b, blockedFieldClassList);
            element.removeAttribute('disabled');
        },
        showElement: function (element) {
            element.classList.remove('hidden');
        },
        hideElement: function (element) {
            element.classList.add('hidden');
        },
        markRed: function (element) {
            element.classList.remove('text-green-500');
            element.classList.add('text-red-500');
        }
    };
    window.addEventListener('load', onLoginFlowLoad);
});
